module.exports = __webpack_public_path__ + "media/home/diamond-services-288830de.svg";